export const Entidade = {
  idenEventoCertidao: 0,
  certidao: {
    idenCertidao: 0,
  },
  tipoEventoCertidao: {
    descTipoEventoCertidao: null,
    siglTipoEventoCertidao: null,
  },
  amparoLegal: {
    idenAmparoLegal: 0,
    descComplementoAmparo: "",
  },
  numrSeqEventoCertidao: 0,
  dataEventoCertidao: new Date().toLocaleDateString(),
  descComplemento: "",
  statEventoCertidao: 0,
  valorEvento: 0,
  valorEventoAnterior: 0,
  valorEventoPos: 0,
  siglaTipoEventoCertidao: "",
  listaAmparoLegalCertidao: [],
};

const url = "eventocertidoes";

export const listaTipoEventoCertidao = [
  { code: "COMP_TOTAL", label: "Compensação Total" },
  { code: "COMP_PARCIAL", label: "Compensação Parcial" },
];

export const listaTipoEventoQuitacao = [
  { code: "QUIT_TOTAL", label: "Quitação Total" },
  { code: "QUIT_PARCIAL", label: "Quitada Parcial" },
];

export const getListaCompensacoes = (idenCertidao) => {
  return new Promise((resolve, reject) => {
    window.$http.get(`${url}/compensacao/${idenCertidao}`).then((res) => {
      resolve(res);
    });
  });
};

export const getListaQuitacao = (idenCertidao) => {
  return new Promise((resolve, reject) => {
    window.$http.get(`${url}/quitacao/${idenCertidao}`).then((res) => {
      resolve(res);
    });
  });
};

export const salvarCompensacao = (dados) => {
  return new Promise((resolve, reject) => {
    let JsonPost = {
      idenCertidao: dados.certidao ? dados.certidao.idenCertidao : null,
      descComplemento: dados.descComplemento ? dados.descComplemento : null,
      listaAmparoLegalCertidao: dados.listaAmparoLegalCertidao ? dados.listaAmparoLegalCertidao : null,
      siglaTipoEventoCertidao: dados.tipoEventoCertidao && dados.tipoEventoCertidao.siglTipoEventoCertidao ? dados.tipoEventoCertidao.siglTipoEventoCertidao.code : null,
      dataEventoCertidao: dados.dataEventoCertidao ? dados.dataEventoCertidao : null,
      idenEventoCertidao: dados.idenEventoCertidao,
      valorEvento: dados.valorEvento,
      empresa: dados.empresa,
    };
    if (dados.idenEventoCertidao === 0) {
      window.$http.post(`${url}/compensacao`, JSON.stringify(JsonPost)).then((res) => {
        resolve(res.data);
      });
    } else {
      alterarEventoCertidao(JsonPost, resolve);
    }
  });
};

export const salvarQuitacao = (dados) => {
  return new Promise((resolve, reject) => {
    let JsonPost = {
      idenCertidao: dados.certidao ? dados.certidao.idenCertidao : null,
      descComplemento: dados.descComplemento ? dados.descComplemento : null,
      listaAmparoLegalCertidao: dados.amparoLegal ? dados.amparoLegal : null,
      siglaTipoEventoCertidao: dados.tipoEventoCertidao && dados.tipoEventoCertidao.siglTipoEventoCertidao ? dados.tipoEventoCertidao.siglTipoEventoCertidao.code : null,
      dataEventoCertidao: dados.dataEventoCertidao ? dados.dataEventoCertidao : null,
      idenEventoCertidao: dados.idenEventoCertidao,
      valorEvento: dados.valorEvento,
      valorEventoAnterior: dados.valorEventoAnterior,
      valorEventoPos: dados.valorEventoPos,
      empresa: dados.empresa,
    };

    if (dados.idenEventoCertidao === 0) {
      window.$http.post(`${url}/quitacao`, JSON.stringify(JsonPost)).then((res) => {
        resolve(res.data);
      });
    } else {
      //   dados.tipoEventoCertidao.siglTipoEventoCertidao = dados.tipoEventoCertidao.siglTipoEventoCertidao.code
      //   dados.listaAmparoLegalCertidao = dados.listaAmparoLegal.map(e =>{
      //    return {
      //       amparoLegal:e
      //    }
      //  })
      alterarEventoCertidao(JsonPost, resolve);
    }
  });
};

export const salvarAutenticacao = (dados) => {
  return new Promise((resolve, reject) => {
    let JsonPost = {
      idenCertidao: dados.idenCertidao,
      siglaTipoEventoCertidao: "AUTENT",
      dataEventoCertidao: dados.dataEventoCertidao,
      descComplemento: dados.descComplemento,
      listaAmparoLegalCertidao: dados.listaAmparoLegalCertidao,
    };

    window.$http.post(`${url}/autenticacao`, JSON.stringify(JsonPost)).then((res) => {
      resolve(res.data);
    });
  });
};

const alterarEventoCertidao = (dados, resolve) => {
  window.$http.put(`${url}/${dados.idenEventoCertidao}`, JSON.stringify(dados)).then((res) => {
    resolve(res.data);
  });
};
